"use strict";
/*
 * Created on 2019-03-25
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../../core/model/errors/conversions/ValidationResultConverter");

var utils_1 = require("../../../core/utils");

var SelloutReleaseItem_1 = require("../../model/sellout/SelloutReleaseItem");

var SelloutReleaseType_1 = require("../../model/sellout/SelloutReleaseType");

var SelloutReleaseItemConverter_1 = require("./SelloutReleaseItemConverter");

var SelloutReleaseItemEvaluationConverter_1 = require("./SelloutReleaseItemEvaluationConverter");

var SelloutReleaseItemPricesConverter_1 = require("./SelloutReleaseItemPricesConverter");

var SelloutReleaseItemSnapshotConverter_1 = require("./SelloutReleaseItemSnapshotConverter");

var SelloutReleaseItemSupplyDataConverter_1 = require("./SelloutReleaseItemSupplyDataConverter");

var SelloutSourceImpactValuesConverter_1 = require("./SelloutSourceImpactValuesConverter");
/**
 * @author JMr
 */


var SelloutReleaseItemConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseItemCo) {
  _inherits(SelloutReleaseItemConverterImpl, _SelloutReleaseItemCo);

  function SelloutReleaseItemConverterImpl(validationResultConverter, releaseItemSupplyDataConverter, releaseItemPricesConverter, releaseItemEvaluationConverter, selloutReleaseItemSnapshotConverter, sourceImpactValuesConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemConverterImpl).call(this));
    _this.validationResultConverter = validationResultConverter;
    _this.releaseItemSupplyDataConverter = releaseItemSupplyDataConverter;
    _this.releaseItemPricesConverter = releaseItemPricesConverter;
    _this.releaseItemEvaluationConverter = releaseItemEvaluationConverter;
    _this.selloutReleaseItemSnapshotConverter = selloutReleaseItemSnapshotConverter;
    _this.sourceImpactValuesConverter = sourceImpactValuesConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseItemConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseItem_1.SelloutReleaseItem(SelloutReleaseItem_1.SelloutReleaseItem.schema.id.valueOf(conversions.documentToClassId(source)), SelloutReleaseItem_1.SelloutReleaseItem.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), SelloutReleaseItem_1.SelloutReleaseItem.schema.releaseType.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.siteId.valueOf(conversions.toClassReferenceId(source.siteId)), SelloutReleaseItem_1.SelloutReleaseItem.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), SelloutReleaseItem_1.SelloutReleaseItem.schema.productExternalId.valueOfField(source), utils_1.Utils.isValueMissing(source.productName) ? ''
      /* Temporary default for backward compatibility, can be removed in production */
      : SelloutReleaseItem_1.SelloutReleaseItem.schema.productName.valueOfField(source), conversions.asObjectList(source, 'categoryIds', function (id) {
        return conversions.toClassReferenceId(id);
      }), SelloutReleaseItem_1.SelloutReleaseItem.schema.weighted.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.categorySpacePlanning.valueOfField(source), conversions.asObjectOpt(source, 'minPriceChangeInPercent', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'maxPriceChangeInPercent', function (v) {
        return conversions.toBigNumber(v);
      }), conversions.asObjectOpt(source, 'minMarginChangeInPercent', function (v) {
        return conversions.toBigNumber(v);
      }), SelloutReleaseItem_1.SelloutReleaseItem.schema.endDate.valueOfField(source), utils_1.Utils.isValueMissing(source.supplyData) ? null : SelloutReleaseItem_1.SelloutReleaseItem.schema.supplyData.valueOf(this.releaseItemSupplyDataConverter.toObject(source.supplyData, conversions)), SelloutReleaseItem_1.SelloutReleaseItem.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), conversions.asObject(source, 'prices', function (doc) {
        return _this2.releaseItemPricesConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'evaluation', function (doc) {
        return _this2.releaseItemEvaluationConverter.toObject(doc, conversions);
      }), SelloutReleaseItem_1.SelloutReleaseItem.schema.readonly.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.uploaded.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.exported.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.reexport.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.exportedDate.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.selloutDetected.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.selloutEnded.valueOfField(source), SelloutReleaseItem_1.SelloutReleaseItem.schema.terminatedByUser.valueOfField(source), this.validationResultConverter.toObject(source.validationResult, conversions), conversions.asObjectList(source, 'reopenSnapshots', function (doc) {
        return _this2.selloutReleaseItemSnapshotConverter.toObject(doc, conversions);
      }), SelloutReleaseItem_1.SelloutReleaseItem.schema.endReason.valueOfField(source), source.newSelloutTypes !== null ? conversions.asObjectList(source, 'newSelloutTypes', function (doc) {
        return conversions.asEnum(doc, SelloutReleaseType_1.SelloutReleaseType);
      }) : null, conversions.asObjectList(source, 'sourceImpactValuesHistory', function (doc) {
        return _this2.sourceImpactValuesConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        releaseType: source.releaseType,
        siteId: conversions.toDocumentReferenceId(source.siteId),
        productId: conversions.toDocumentReferenceId(source.productId),
        productExternalId: source.productExternalId,
        productName: source.productName,
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        weighted: source.weighted,
        categorySpacePlanning: source.categorySpacePlanning,
        minPriceChangeInPercent: conversions.asObjectOpt(source, 'minPriceChangeInPercent', function (v) {
          return conversions.fromBigNumber(v);
        }),
        maxPriceChangeInPercent: conversions.asObjectOpt(source, 'maxPriceChangeInPercent', function (v) {
          return conversions.fromBigNumber(v);
        }),
        minMarginChangeInPercent: conversions.asObjectOpt(source, 'minMarginChangeInPercent', function (v) {
          return conversions.fromBigNumber(v);
        }),
        endDate: source.endDate !== null ? conversions.fromDate(source.endDate) : null,
        supplyData: source.supplyData !== null ? this.releaseItemSupplyDataConverter.toDocument(source.supplyData, conversions) : null,
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        prices: this.releaseItemPricesConverter.toDocument(source.prices, conversions),
        evaluation: conversions.asObjectOpt(source, 'evaluation', function (obj) {
          return _this3.releaseItemEvaluationConverter.toDocument(obj, conversions);
        }),
        readonly: source.readonly,
        uploaded: source.uploaded,
        exported: source.exported,
        reexport: source.reexport,
        exportedDate: utils_1.Utils.isMoment(source.exportedDate) ? conversions.fromDate(source.exportedDate) : null,
        selloutDetected: conversions.fromDate(source.selloutDetected),
        selloutEnded: source.selloutEnded,
        terminatedByUser: source.terminatedByUser,
        validationResult: this.validationResultConverter.toDocument(source.validationResult, conversions),
        reopenSnapshots: conversions.asObjectArray(source, 'reopenSnapshots', function (v) {
          return _this3.selloutReleaseItemSnapshotConverter.toDocument(v, conversions);
        }),
        endReason: source.endReason,
        newSelloutTypes: source.newSelloutTypes && conversions.asObjectArray(source, 'newSelloutTypes', function (v) {
          return v;
        }),
        sourceImpactValuesHistory: conversions.asObjectArray(source, 'sourceImpactValuesHistory', function (v) {
          return _this3.sourceImpactValuesConverter.toDocument(v, conversions);
        })
      });
      return result;
    }
  }]);

  return SelloutReleaseItemConverterImpl;
}(SelloutReleaseItemConverter_1.SelloutReleaseItemConverter);

SelloutReleaseItemConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __param(4, typescript_ioc_1.Inject), __param(5, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ValidationResultConverter_1.ValidationResultConverter, SelloutReleaseItemSupplyDataConverter_1.SelloutReleaseItemSupplyDataConverter, SelloutReleaseItemPricesConverter_1.SelloutReleaseItemPricesConverter, SelloutReleaseItemEvaluationConverter_1.SelloutReleaseItemEvaluationConverter, SelloutReleaseItemSnapshotConverter_1.SelloutReleaseItemSnapshotConverter, SelloutSourceImpactValuesConverter_1.SelloutSourceImpactValuesConverter])], SelloutReleaseItemConverterImpl);
exports.SelloutReleaseItemConverterImpl = SelloutReleaseItemConverterImpl;